// NOTE: ErrorBoundary と ssrHydrator の両方から呼び出し順不定で呼ばれるため、初期化は冪等にする。

import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

let initialized = false;

export default function initSentryOnce() {
  if (typeof window === 'undefined' || initialized) return;
  initialized = true;

  Sentry.init({
    // 本番環境のみエラー通知
    dsn: process.env.NODE_ENV === 'production'
      ? 'https://8f781d4beb004ab999d7fd14d84fe1b9@o4504274116018176.ingest.sentry.io/4504274162417664'
      : false,

    integrations: [new BrowserTracing()],
    environment: process.env.NODE_ENV,

    // 参考：https://blog.studysapuri.jp/entry/2022/10/03/team-sentry-operation
    // エラー数が必要以上に増えて上限を超えないよう、botアクセスによるものやユーザ影響のないものは除外
    ignoreErrors: [
      'ReferenceError', // botアクセスが中心：「Can't find variable: IntersectionObserver」など
      'Network Error', // ユーザーの回線状況が原因の場合が多い
      'Failed to fetch',
      'Load failed',
      'No error message',
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,
    beforeSend(event) {
      // Modify the event here
      if (event.user) {
        // Don't send user's email address
        /* eslint-disable no-param-reassign */
        delete event.user.email;
        delete event.user.ip_address;
        delete event.user.username;
        /* eslint-enable no-param-reassign */
      }
      return event;
    },
  });
}
